
import { useCallback, useState, useContext, useEffect } from "react";
import {addOrganizationWfh } from "../ApplyLeave/Wfh/WfhSerevice";
import { getOrganizationBranch,deleteOrganizationBranch } from "./Services/AdvanceSettingService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";

const OrgBranchSetting = () => {
  const [columns, setColumns] = useState(["BranchName", "AddressId", "BranchCode"]); // Columns state
  const [rows, setRows] = useState([{}]);
  const [editIndex, setEditIndex] = useState(null);
  const [orgBranchList,setOrgBranchList] = useState([]);
  const [selectedId, SetSelectedId] = useState();
  const defaultImage = "/images/placeholder_profile.png";
  const [orgBranchId, setOrgBranchId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
const [data, setData] = useState({
    WFHType: "",
    Desc: "",
  });
    let SearchValue = "";


  useEffect(() => {
    GetOrgBranch();
  }, []);

  const validateOrgWfh = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-WFHType`] =
      !data.WFHType || data.WFHType.trim() === ""
        ? "WFH Type is required"
        : undefined;
    newErrors[`${index}-Desc`] =
      !data.Desc || data.Desc.trim() === ""
        ? "Desc is required"
        : undefined;    
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetOrgBranch() {
    setIsloading(true);
    try {
      let responce = await getOrganizationBranch({});
      setOrgBranchList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgBranchList([
      ...orgBranchList,
      { LeaveType: "", Desc: ""},
    ]);
    setEditIndex(orgBranchList.length);
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const handleChange = (rowIdx, colName) => (e) => {
  const { value } = e.target;
  setOrgBranchList(prevList => {
    const newList = prevList.map((item, idx) =>
      idx === rowIdx ? { ...item, [colName]: value } : item
    );
    return newList;
  });
  setData(prev => ({ ...prev, [colName]: value }));
  validateOrgWfh({ ...orgBranchList[rowIdx], [colName]: value }, rowIdx);
};

  const cancelOrgWfh = () => {
  GetOrgBranch();
  setOrgBranchList(prevList => {
    setEditIndex(null);
    const len = prevList.length;
    if (len === 0) return prevList;
    const lastItem = prevList[len - 1];
    const isEmpty = lastItem &&
      !lastItem.WFHType &&
      !lastItem.Desc ;
    if (isEmpty) {
      return prevList.slice(0, -1);
    }
    return prevList;
  });
}

  useEffect(() => { }, [selectedId]);
  async function addOrgWfh(index, data) {
    let selectedFrequencyIdId;
    if (selectedId) {
      selectedFrequencyIdId = selectedId;
    } else {
      selectedFrequencyIdId = data?.FrequencyId;
    }
    const body = {
    Id: data?.Id || 0,
    WFHTypeId: data.WFHTypeId || 0,
    WFHType: data.WFHType,
    Desc: data.Desc,
    Frequency: data.Frequency,
    CreditCount: parseInt(data.CreditCount, 10),
    ExpiryFrequency: data.ExpiryFrequency,
    ExpiryCount: parseInt(data.ExpiryCount, 10),
    AccumulationLimit: parseInt(data.AccumulationLimit, 10),
    AdvanceWFHWindow: parseInt(data.AdvanceLeaveWindow, 10),
    PastWFHWindow: parseInt(data.PastLeaveWindow, 10),
    AdvanceNotice: parseInt(data.AdvanceNotice, 10),
    };
    try {
      await addOrganizationWfh(body);
      if (orgBranchId) {
        alert('Org Leave Updated');
      } else {
        alert('Org Leave Added');
      }
      SetSelectedId(null);
      setOrgBranchList([]);
      setEditIndex(null);
      GetOrgBranch();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleBranchlstDelete = (Id) => {
    setOrgBranchId(Id);
  };

   async function DeleteOrgBranch() { 
      setIsloading(true);
      if (orgBranchId) {
        let body = {
          Id: orgBranchId,
        };
        try {
          let orgPolicyDeleteList = await deleteOrganizationBranch(body);
          if (orgPolicyDeleteList) {
            setIsloading(false);
            GetOrgBranch();
          }
        } catch (error) {
          toster.current.error(ERROR_LIST.DefaultError);
        }
      }
    }

    const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgBranchList.filter((orgBranch) =>
        orgBranch.BranchName?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgBranchList(filteredList);
      } else {
        GetOrgBranch();
      }
    }, 800),
    [orgBranchList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
        </div>
        <div className="title-text">
          <h3>Branch Types ({orgBranchList?.length})</h3>
          <div className="d-flex">
          <InputText
            name="requestTitle"
            className="form-control search-grpname me-2"
            onChange={handleInputChange}
            placeholder="Search"
          />

          {!editIndex && (
            <button
              className="addaward-btn"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-bs-original-title=""
              fdprocessedid="izng1j"
              onClick={handleAddRow}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
              </svg>
              Branch
            </button>
          )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgBranchList?.map((data, index) => (
                <tr key={index}>                 
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          value={data.BranchName}
                          onChange={handleChange(index, "BranchName")}
                          placeholder="Branch Name"
                          className={`form-control ${errors[`${index}-BranchName`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-BranchName`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-BranchName`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          value={data.AddressId}
                          onChange={handleChange(index, "AddressId")}
                          placeholder="Address-Id"
                          className={`form-control ${errors[`${index}-AddressId`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-AddressId`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-AddressId`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <input
                          value={data.BranchCode}
                          onChange={handleChange(index, "BranchCode")}
                          placeholder="Branch Code "
                          className={`form-control ${errors[`${index}-BranchCode`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-BranchCode`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-BranchCode`]}
                          </div>
                        )}
                      </td>                    
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                            onClick={() => {
                            if (validateOrgWfh(data, index)) { 
                            addOrgWfh(index, data);
                            setEditIndex(null);
                            }
                           }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.BranchName}</td>
                      <td>{data?.AddressId}</td>
                      <td>{data?.BranchCode}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-branch"
                          onClick={() => {
                            handleBranchlstDelete(data?.Id);
                            // GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-branch">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Branch?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgBranch()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgBranchSetting;
